/* eslint-disable @typescript-eslint/no-explicit-any */
import request from 'utils/request';

const installmentService = {
  getList: (params: any) => request.get('/installment-product', { params }),
  getInstallmentById: (id: any) => request.get(`/installment-product/${id}`),
  createInstallment: (data: any) => request.post('/installment-product', data),
  deleteInstallment: (id: any) => request.delete(`/installment-product/${id}`),
  updateInstallment: (id: any, data: any) =>
    request.put(`/installment-product/${id}`, data)
};

export default installmentService;
